import { isProd } from '../configs/env';

const saProductsStage = [
  '8276617265378', // v2 placeholder
  '8617528295650', // v3 pending lte
  '8617527574754', // v3 pending hotspot
  '8617524035810', // v3 lte device
  '8617524003042', // v3 hotspot device
  '8617525543138', // v3 final bundle
];

const saProductsProd = [
  '8931617833191', // v3 pending lte
  '8931617243367', // v3 pending hotspot
  '8500223017191', // v3 hotspot device
  '8794518585575', // v3 lte device
  '8892905095399', // v3 final bundle
];

const saSwapProductMappingStage = {
  8617528295650: '8617524035810', // pending lte to plan
  8617527574754: '8617524003042', // pending hotspot to plan
};

const saSwapProductMappingProd = {
  8931617833191: '8794518585575', // pending lte to plan
  8931617243367: '8500223017191', // pending hotspot to plan
};

const saChargeVariantMappingStage = {
  45628347777250: '45628342501602', // hotspot 200gb
  45628347810018: '45628342534370', // hotspot 300gb
  45628347842786: '45628342567138', // hotspot 450gb
  45628347875554: '45628342599906', // hotspot 800gb
  45628347908322: '45628342665442', // lte 200gb
  45628347941090: '45628342698210', // lte 300gb
  45628347973858: '45628342730978', // lte 450gb
  45628348006626: '45628342763746', // lte 800gb
};

const saChargeVariantMappingProd = {
  49678353236199: '47887459221735', // hotspot 200gb
  49678353268967: '47887459254503', // hotspot 300gb
  49678353301735: '47887459287271', // hotspot 450gb
  49678353334503: '47887459320039', // hotspot 800gb
  49678377550055: '49209547456743', // lte 200gb
  49678377582823: '49209547489511', // lte 300gb
  49678377615591: '49209547522279', // lte 450gb
  49678377648359: '49209547555047', // lte 800gb
};

const prod = isProd();

// products that requires charges before activation
export const SA_CHARGE_PRODUCTS = prod ? saProductsProd : saProductsStage;

// products that will be change during activation to another product
export const SA_SWAP_PRODUCT_MAPPING = prod
  ? saSwapProductMappingProd
  : saSwapProductMappingStage;

// bundle variant to plan variant map to check if plan was already payed
export const SA_CHARGE_VARIANT_MAPPING = prod
  ? saChargeVariantMappingProd
  : saChargeVariantMappingStage;
